<template>
  <div>
    <vue-qrcode :value="value" ref="qrcode"></vue-qrcode>
    <button @click="downloadQRCode">下载二维码</button>
  </div>
</template>

<script>
import { ref } from "vue";
import VueQrcode from "@chenfengyuan/vue-qrcode";

export default {
  props: ['value'],
  components: {
    VueQrcode,
  },
  setup() {
    const qrcode = ref(null);

    const downloadQRCode = () => {
      const canvas = qrcode.value.$el;
      debugger;
      const a = document.createElement("a");
      a.href = canvas.toDataURL("image/png");
      a.download = "qrcode.png";
      a.click();
    };

    return {
      qrcode,
      downloadQRCode,
    };
  },
};
</script>
